import { useMemo } from 'react';
import { fetchCampaignLabelsQuery } from 'api/queries';
import { useGraphql } from 'utils/hooks/useGraphql';
import { Label } from '../../../domain';

export const useCampaignLabels = () => {
  const { data: campaignLabelsData = {} } = useGraphql(fetchCampaignLabelsQuery);
  const campaignLabelsLookup = useMemo(() => {
    const labels: Label[] = campaignLabelsData?.campaignLabels || [];
    return labels.reduce((lookup, label) => ({ ...lookup, [label.id]: label.name }), {});
  }, [campaignLabelsData]);
  return campaignLabelsLookup;
};
